import { DropdownSection } from '@leagueplatform/web-common-components';
import { BoxProps } from '@leagueplatform/genesis-commons';
import {
  AUTHED_WEBVIEW_URL_NAMES,
  getAuthedWebviewUrl,
  injectCobrowseInitiator,
  LinkHandler,
  UserDropdownProps,
} from '@leagueplatform/highmark-common';
import { COB_URL } from 'common/constants';

export const getUserDropdownConfig = (qualifiers: UserDropdownProps) => {
  const accountManagementUrl = getAuthedWebviewUrl(
    AUTHED_WEBVIEW_URL_NAMES.ACCOUNT_MANAGEMENT,
  );

  const userDropdownConfig: DropdownSection[] = [
    [
      {
        text: 'ACCOUNT_MANAGEMENT',
        to: accountManagementUrl,
        onClick: () => {
          LinkHandler.handleLink(accountManagementUrl);
        },
      },
      // Conditionally add COB Link to list if insuranceAdministeredByThirdParty is true
      ...(qualifiers?.insuranceAdministeredByThirdParty
        ? [
            {
              text: 'COORDINATION_OF_BENEFITS',
              to: COB_URL,
              target: '_blank',
            },
          ]
        : []),
      // Conditionally add CoBrowse link to list if feature flag is enabled
      ...(qualifiers?.isCobrowseEnabled
        ? [
            {
              text: 'START_COBROWSE',
              to: '',
              onClick: () => {
                injectCobrowseInitiator();
              },
            },
          ]
        : []),
    ],
    [
      {
        text: 'ABOUT_ALLMYHEALTH',
        to: '/about',
      },
    ],
    [
      {
        to: '/sign-out',
        text: 'LOG_OUT',
        linkProps: {
          color: 'onSurface.text.critical',
        } as BoxProps,
      },
    ],
  ];

  return userDropdownConfig;
};
